// This enum is used to map technical descriptive names to Partou Google Analytics definitions
export enum EventName {
  WorkflowTake = 'State_PakOp',
  WorkflowRelease = 'State_Vrijgeven',
  WorkflowOvertake = 'State_Overnemen',
  WorkflowFinalize = 'State_ActieUitgezet',

  MatchDetailsEmailClicked = 'CandidateInfo_Email',
  MatchDetailsGoogleMapsClicked = 'CandidateInfo_GoogleMaps',
  MatchDetailsCoupleCandidate = 'CandidateInfo_Match',
  MatchDetailsConfirmCandidate = 'CandidateInfo_MatchConfirm',
  MatchDetailsRejectCandidate = 'CandidateInfo_Annuleren',

  RequestDetailOpened = 'Project_ToonDetails',
  RequestDetailHistory = 'Project_Historie',
  RequestDetailDecline = 'Project_Decline',

  RequestsRefresh = 'Data_Refresh',

  AuditExport = 'Data_Export',
}

export enum EventDescription {
  WorkflowTake = 'Gebruiker klikt op statusbutton: Pak op',
  WorkflowRelease = 'Gebruiker klikt op statusbutton: Vrijgeven',
  WorkflowOvertake = 'Gebruiker klikt op statusbutton: Actie uitgezet',
  WorkflowFinalize = 'Gebruiker klikt op statusbutton: Overnemen',

  MatchDetailsEmailClicked = 'Gebruiker klikt op het e-mailadres',
  MatchDetailsGoogleMapsClicked = 'Gebruiker klikt op Google Maps link',
  MatchDetailsCoupleCandidate = 'Gebruiker klikt op: Koppel aan dienst',
  MatchDetailsConfirmCandidate = 'Gebruiker klikt op: Koppel aan dienst bevestiging',
  MatchDetailsRejectCandidate = 'Gebruiker klikt op: Annuleren',

  RequestDetailOpened = 'Gebruiker klikt op: Toon details',
  RequestDetailHistory = 'Gebruiker klikt op: Historie',
  RequestDetailDecline = 'Gebruiker klikt op: Dienstaanvraag afwijzen',

  RequestsRefresh = 'Gebruikt klikt op: Data refresh button',

  AuditExport = 'Gebruiker klikt op: Export historie',
}

// TODO : Refactor to const
export enum EventCategory {
  WorkflowTake = 'Aanvragen: Workflow states',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  WorkflowRelease = 'Aanvragen: Workflow states',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  WorkflowOvertake = 'Aanvragen: Workflow states',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  WorkflowFinalize = 'Aanvragen: Workflow states',

  MatchDetailsEmailClicked = 'Kandidaat informatie',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  MatchDetailsGoogleMapsClicked = 'Kandidaat informatie',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  MatchDetailsCoupleCandidate = 'Kandidaat informatie',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  MatchDetailsConfirmCandidate = 'Kandidaat informatie',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  MatchDetailsRejectCandidate = 'Kandidaat informatie',

  RequestDetailOpened = 'Dienst details',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  RequestDetailHistory = 'Dienst details',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  RequestDetailDecline = 'Dienst details',

  RequestsRefresh = 'Dienst refresh',

  AuditExport = 'Audit export',
}
